/* eslint-disable quote-props */
export const darkModeCardStyle = {
  ".input-container": {
    borderColor: "#fff",
  },
  ".input-container.is-focus": {
    borderColor: "#FEC20B",
    borderWidth: "1px",
  },
  ".input-container.is-error": {
    borderColor: "#ED7857",
  },
  ".message-text": {
    color: "#999999",
  },
  ".message-icon": {
    color: "#999999",
  },
  ".message-text.is-error": {
    color: "#ED7857",
  },
  ".message-icon.is-error": {
    color: "#ED7857",
  },
  input: {
    backgroundColor: "#FFF",
    fontFamily: "helvetica neue, sans-serif",
    fontSize: "14px",
  },
  "input::placeholder": {
    color: "#999999",
  },
  "input.is-error": {
    color: "#ED7857",
  },
};
